import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTrending1"><Path fillRule="evenodd" clipRule="evenodd" d="M13.1317 1.60352L18.1855 18.281L20.9332 13.0497L22.2612 13.7472L17.8114 22.2189L12.8652 5.89642L8.09776 16.6232L4.9323 11.3474L2.90367 14.0805L1.69922 13.1864L5.06462 8.65249L7.89916 13.3767L13.1317 1.60352Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending1;
